import { render, staticRenderFns } from "./BannerHeroEdit.vue?vue&type=template&id=4ee8fe62&"
import script from "./BannerHeroEdit.vue?vue&type=script&lang=js&"
export * from "./BannerHeroEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports